/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrSectionHeader } from './igr-section-header';
import { SectionHeader } from './SectionHeader';
import { TypeRegistrar } from "igniteui-react-core";
var IgrSectionHeaderModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrSectionHeaderModule() {
    }
    IgrSectionHeaderModule.register = function () {
        TypeRegistrar.registerCons("IgrSectionHeader", IgrSectionHeader);
        TypeRegistrar.register("SectionHeader", SectionHeader.$type);
    };
    return IgrSectionHeaderModule;
}());
export { IgrSectionHeaderModule };
//# sourceMappingURL=igr-section-header-module.js.map
